<template>
  <div class="singertrending">
    <div class="p-2">
      <div v-for="(item, i) in dataList" v-if="i==0" class="col-md-4 float-left featured pl-0 pr-0">
        <a :href="prefixUrl + item.id">
          <img :src="item.thumbnail"/>
        </a>
      </div>
      <div class="col-md-8 float-left pl-0 pr-0">
        <div class="comp-title">
          <div class="left">
            <h1 class="text-uppercase color-text-bold mt-2 mb-2">
              Top nghệ sĩ trending trong tuần
            </h1>
          </div>
        </div>
        <div class="parent expand" style="clear: both"></div>

        <div class="row singertop mt-2 mb-4">
          <div class="col-md-6 float-left text-left pl-0 pr-0">
            <div v-for="(item, i) in dataList" v-if="i < 5" class="item">
              <a :href="prefixUrl + item.id">
                <span class="ordernumber float-left" :class="{ orderone : i == 0, ordertwo : i == 1, orderthree : i == 2 }">{{ i + 1 }}</span>
                <img class="thumbnail float-left mr-2" :src="item.thumbnail != '' ? item.thumbnail : thumbnailDefault"/>
                <h4 class="song color-text">{{ item.singer }}</h4>
              </a>
              <div class="parent expand" style="clear: both"></div>
            </div>
          </div>

          <div class="col-md-6 float-left text-left pl-0 pr-0">
            <div v-for="(item, i) in dataList" v-if="i >= 5" class="item">
              <a :href="prefixUrl + item.id">
                <span class="ordernumber float-left" :class="{ orderten : i==9 }">{{ i+1 }}</span>
                <img class="thumbnail float-left mr-2" :src="item.thumbnail != '' ? item.thumbnail : thumbnailDefault"/>
                <h4 class="song color-text">{{ item.singer }}</h4>
              </a>
              <div class="parent expand" style="clear: both"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Trending",
    data () {
      return {
        thumbnailDefault: this.settings.defaultThumbnailSong,
        prefixUrl: this.settings.prefixSinger,
        dataList: [
          /*{
            "code": "dt",
            "singer": "Đan Trường",
            "thumbnail": "https://avatar-nct.nixcdn.com/singer/avatar/2016/04/22/6/f/4/8/1461289949173_600.jpg"
          },
          {
            "code": "dt",
            "singer": "Đan Trường",
            "thumbnail": "https://avatar-nct.nixcdn.com/singer/avatar/2016/04/22/6/f/4/8/1461289949173_600.jpg"
          },
          {
            "code": "dt",
            "singer": "Đan Trường",
            "thumbnail": "https://avatar-nct.nixcdn.com/singer/avatar/2016/04/22/6/f/4/8/1461289949173_600.jpg"
          },
          {
            "code": "dt",
            "singer": "Đan Trường",
            "thumbnail": "https://avatar-nct.nixcdn.com/singer/avatar/2016/04/22/6/f/4/8/1461289949173_600.jpg"
          },
          {
            "code": "dt",
            "singer": "Đan Trường",
            "thumbnail": "https://avatar-nct.nixcdn.com/singer/avatar/2016/04/22/6/f/4/8/1461289949173_600.jpg"
          },
          {
            "code": "dt",
            "singer": "Đan Trường",
            "thumbnail": "https://avatar-nct.nixcdn.com/singer/avatar/2016/04/22/6/f/4/8/1461289949173_600.jpg"
          },
          {
            "code": "dt",
            "singer": "Đan Trường",
            "thumbnail": "https://avatar-nct.nixcdn.com/singer/avatar/2016/04/22/6/f/4/8/1461289949173_600.jpg"
          },
          {
            "code": "dt",
            "singer": "Đan Trường",
            "thumbnail": "https://avatar-nct.nixcdn.com/singer/avatar/2016/04/22/6/f/4/8/1461289949173_600.jpg"
          },
          {
            "code": "dt",
            "singer": "Đan Trường",
            "thumbnail": "https://avatar-nct.nixcdn.com/singer/avatar/2016/04/22/6/f/4/8/1461289949173_600.jpg"
          },
          {
            "code": "dt",
            "singer": "Đan Trường",
            "thumbnail": "https://avatar-nct.nixcdn.com/singer/avatar/2016/04/22/6/f/4/8/1461289949173_600.jpg"
          }*/
        ]
      }
    },
    methods: {
      getListSingerTop(){
        axios.post(api.singerTop, {pageSize: 10})
          .then(response => {
            this.dataList = response.data.result;
          })
          .catch(e => {
            console.log("SingerTop-----");
            console.log(e);
          });
      }
    },
    watch: {
      "$route.path": {
        handler: function (val) {
          this.getListSingerTop();
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .item{
    border-bottom: 1px solid #ccc;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .singertrending{
    background-color: #fff;
    min-height: 100px;
  }
  .featured img{
    width:100%;
    height: 350px;
  }
  .comp-title{
    margin: 0 !important;
  }
  .thumbnail{
    width: 60px;
    height: 60px;
  }
  .ordernumber{
    background-color: #828282;
    padding: 4px 11px;
    border-radius: 30px;
    color: #fff;
    margin-right: 4px;
    font-weight: bold;
    font-size: 16px;
  }
  .orderten{
    padding: 4px 7px !important;
  }
  .orderone{
    background-color: #ff4c4c;
  }
  .ordertwo{
    background-color: #ff9519;
  }
  .orderthree{
    background-color: #00a4e9;
  }
</style>



// WEBPACK FOOTER //
// src/components/singer/wap/Trending.vue